import React, { useEffect, useState } from "react";
import Ico from "../assets/images/icos.png";
import __ from "../assets/images/__.png";
import Modal from "../components/Modal";
import { Link } from "react-router-dom";
import Skeleton from "./Skeleton";
import Button from "../components/Button";
function Hero({ data, loading }) {
  const [screen, setScreen] = useState();
  const [openModal, setOpenModel] = useState(false);

  // console.log(loading, "data");
  useEffect(() => {
    if (window.screen.availWidth < 760) {
      setScreen("Mobile");
    } else {
      setScreen("DesKtop");
    }
    if (loading) {
      const hiddenElements = document.querySelectorAll(".structure");
      hiddenElements.forEach((item) => {
        item.style.opacity = "0";
      });
    } else {
      const hiddenElements = document.querySelectorAll(".structure");
      hiddenElements.forEach((item) => {
        item.style.opacity = "1";
      });
    }
  });

  return (
    <>
      <Modal open={openModal} onClose={() => setOpenModel(false)} />
      <div
        className="hero holder"
        style={{
          backgroundPosition: "center",
          backgroundImage: `url(${
            screen == "Mobile" ? data?.heroBannerMobile : data?.heroBanner
          })`,
        }}
      >
        <div className="wrapper">
          <div className="row">
            <div className="pd-intro col-md-6 col-sm-12 hidden">
              <div className=" hero-content">
                <h2>
                  <div
                    dangerouslySetInnerHTML={{ __html: data?.heroHeading }}
                  />
                </h2>
              </div>
              <br />
              <p>{data?.heroSubHeading}</p>
              <div className="row btn-container">
                <div className="col-4 ">
                  <Button
                    style="structure primary btn large mw-110"
                    text="Listen"
                    onClick={() => setOpenModel(!openModal)}
                  />
                </div>
                <div className="col-8">
                  <Link to="/podcasts">
                    <button className="structure secondary btn large">
                      Current Episodes
                    </button>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-12"></div>
          </div>
          <br />
        </div>
        <img className="ico-img" src={Ico} alt="" />
      </div>
    </>
  );
}

export default Hero;
